import gql from 'graphql-tag';

export const UPDATE_ORDER = gql`
  mutation updateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input) {
      order {
        id
        comments
      }
      errors
    }
  }
`;

export const GET_ORDER = gql`
  query getOrder($id: ID!) {
    order(id: $id) {
      amountOutstanding
      customer {
        email
        firstName
        fullName
        id
        lastName
        mobilePhone
        phone
        picture
        loyaltyPoints
        blocked
      }
      permissions {
        issueInvoice
      }
      draft
      compliantRegister
      fiscalizationFinished
      employeeNames
      tipAmount
      id
      invoicedAt
      items {
        description
        employee {
          id
          name
        }
        id
        price
        quantity
        originalPrice
        loyaltyPointsAmount
        usedPrepaidCard {
          id
          description
        }
        servicePackageService {
          id
        }
      }
      location {
        internalName
      }
      medical
      number
      state
      total
      transactions {
        id
        description
        amount
        giftcard {
          code
        }
        prepaidCard {
          id
          description
        }
        type
        transactionAt
      }
      documents {
        id
        documentType
        number
        issuedAt
      }
      comments
    }
  }
`;
